module.exports = __webpack_public_path__ + "img/app-layer.97aa72a0.png";